import styles from "./styles.module.scss"
import { observer } from "mobx-react-lite"
import { SearchResultDetailsShip } from "@cruisen/contract"
import { CruiseDetailsCard } from "../../../../cards/CruiseDetailsCard"
import { _t } from "@cruisen/i18n"
import { ErrorHandledImage } from "../../../../atoms/ErrorHandledImage"
import { makeAutoObservable } from "mobx"
import { useMemo } from "react"
import { ImagePreviewModal } from "../../../../modals/ImagePreviewModal"

class ShipCardState {
  isImageZoomModalVisible: boolean
  showFullDescription: boolean

  constructor() {
    this.isImageZoomModalVisible = false
    this.showFullDescription = false

    makeAutoObservable(this)
  }

  setIsImageZoomModalVisible(value: boolean) {
    this.isImageZoomModalVisible = value
  }

  setShowFullDescription(value: boolean) {
    this.showFullDescription = value
  }

  toggleShowFullDescription() {
    this.showFullDescription = !this.showFullDescription
  }
}

export const ShipCard = observer(function ShipCard({ ship }: { ship: SearchResultDetailsShip }) {
  const store = useMemo(() => new ShipCardState(), [])
  if (!ship.name || !ship.description) return null

  return (
    <>
      <CruiseDetailsCard
        title={_t("cruiseDetailsScreen.ship")}
        //testID="cruise-ship-card"
        paddingEnabled={false}
      >
        <div className={styles.container}>
          <button
            className={styles.imageZoomModalButton}
            onClick={() => store.setIsImageZoomModalVisible(true)}
          >
            <ErrorHandledImage
              uri={ship.imageUrl}
              className={styles.shipImage}
              errorMessage="Ship image unavailable"
            />
          </button>
          <p className={styles.shipName}>{ship.name}</p>
          <p className={styles.shipDescription}>
            {store.showFullDescription ? ship.description : `${ship.description.slice(0, 150)}...`}
          </p>
          <button
            className={styles.showMoreButton}
            onClick={() => store.toggleShowFullDescription()}
          >
            {store.showFullDescription ? "Show less" : "Show more"}
          </button>
        </div>
      </CruiseDetailsCard>
      {store.isImageZoomModalVisible ? (
        <ImagePreviewModal
          files={[
            {
              fileName: ship.name,
              fileUrl: ship.hdImageUrl,
            },
          ]}
          onClose={() => store.setIsImageZoomModalVisible(false)}
        />
      ) : null}
    </>
  )
})
